import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import createSagaMiddleware from 'redux-saga';
import sagas from '../sagas/sagas';
import login from './auth/login.store';
import registration from './auth/registration.store';
import user from './user.store';
import makeReservation from './shared/make-reservation.store';
import landing from './customers/landing.store';
import privateRoute from './shared/private-route.store';
import reservationsList from './shared/reservations-list.store';
import logout from './auth/logout.store';
import handleReservation from './admin/handle-reservation.store'
import changepassword from './auth/password-change.store';
import resetPassword from './auth/reset-password.store';
import sendEmail from './shared/send-email.store'
import editProfile from './customers/edit-profile.store'
import roomsList from './customers/rooms-list.store'
import uploadCSV from './customers/upload-csv.store'
import eventsList from './shared/events-list.store'
import listAttendees from './customers/list-attendees.store'

const sagaMiddleware = createSagaMiddleware();

const reducer = combineReducers({
  login: login,
  registration: registration,
  user: user,
  makeReservation: makeReservation,
  landing: landing,
  reservationsList: reservationsList,
  privateRoute: privateRoute,
  logout: logout,
  handleReservation: handleReservation,
  changePassword:changepassword,
  resetPassword: resetPassword,
  sendEmail: sendEmail,
  editProfile: editProfile,
  roomsList: roomsList,
  uploadCSV: uploadCSV,
  eventsList: eventsList,
  listAttendees: listAttendees
});

const store = configureStore({
  reducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({ serializableCheck: false }).concat(sagaMiddleware),
});

sagaMiddleware.run(sagas);

export default store;
